<p-toast />

<p-dialog
  [header]="'reports.dialog.deleteTitle' | translate"
  [(visible)]="deleteDialogVisible"
  [modal]="true"
  styleClass="report-delete-dialog eko-responsive-dialog"
  [style]="{ width: 'min(28rem, 92vw)' }"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="!deleteSaving"
  [closable]="!deleteSaving"
  (onHide)="onDeleteDialogHide()"
>
  <p>
    {{
      'reports.dialog.deleteMessage'
        | translate: { name: rowPendingDelete?.nazwa ?? '' }
    }}
  </p>
  <div class="dialog-footer-actions report-delete-dialog-footer">
    <p-button
      type="button"
      [label]="'reports.dialog.no' | translate"
      severity="secondary"
      [disabled]="deleteSaving"
      (onClick)="cancelDeleteReport()"
    />
    <p-button
      type="button"
      [label]="'reports.dialog.yes' | translate"
      severity="danger"
      [loading]="deleteSaving"
      [disabled]="deleteSaving"
      (onClick)="confirmDeleteReport()"
    />
  </div>
</p-dialog>

<p-dialog
  [header]="getDialogTitleKey() | translate"
  [(visible)]="createDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="!createSaving"
  [closable]="!createSaving"
  styleClass="report-create-dialog eko-responsive-dialog"
  [style]="{ width: 'min(26rem, 94vw)' }"
  (onHide)="onCreateDialogHide()"
>
  <form [formGroup]="createForm" class="report-create-form">
    <div class="field">
      <label for="report-title" class="field-label"
        >{{ 'reports.form.name' | translate }}<span class="text-required">*</span></label
      >
      <input
        id="report-title"
        type="text"
        pInputText
        formControlName="title"
        class="w-full"
        autocomplete="off"
      />
      @if (getCreateFieldError('title')) {
        <small class="p-error">{{ getCreateFieldError('title') }}</small>
      }
    </div>

    <div class="field">
      <label for="report-year" class="field-label"
        >{{ 'reports.form.year' | translate }}<span class="text-required">*</span></label
      >
      <p-select
        inputId="report-year"
        formControlName="year"
        [options]="yearOptions"
        optionLabel="label"
        optionValue="value"
        [placeholder]="'reports.form.yearPlaceholder' | translate"
        styleClass="w-full report-year-select"
        [fluid]="true"
        [loading]="yearsLoading"
        [disabled]="createSaving || yearsLoading || yearOptions.length === 0"
        appendTo="body"
      />
      @if (getCreateFieldError('year')) {
        <small class="p-error">{{ getCreateFieldError('year') }}</small>
      }
    </div>

    <div class="field">
      <label for="report-description" class="field-label">{{ 'reports.form.description' | translate }}</label>
      <textarea
        id="report-description"
        pTextarea
        formControlName="description"
        class="w-full"
        rows="5"
        [autoResize]="true"
      ></textarea>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="report-create-footer">
      <p-button
        type="button"
        [label]="'reports.dialog.save' | translate"
        [loading]="createSaving"
        [disabled]="createSaving || createForm.invalid"
        (onClick)="onSaveCreateReport()"
      />
    </div>
  </ng-template>
</p-dialog>

<div class="reports-page">
  <div class="reports-header">
    <h1 class="reports-title">{{ 'reports.pageTitle' | translate }}</h1>
    <div class="hidden md:flex">
      <p-button
        [label]="'reports.addReport' | translate"
        icon="pi pi-plus"
        (onClick)="onAddReport()"
      />
    </div>
  </div>

  <eko-fab-speed-dial [actions]="pageActions" />

  <eko-generic-table
    #table
    styleClass="p-datatable-gridlines"
    [columnRows]="columnRows"
    [dataProvider]="dataProvider"
    [tableConfig]="tableConfig"
    class="reports-table"
  >
    <ng-template #rowActionsTemplate let-rowData>
      <button
        pButton
        type="button"
        icon="pi pi-pencil"
        class="p-button-rounded p-button-text"
        [pTooltip]="'reports.tooltips.edit' | translate"
        tooltipPosition="top"
        (click)="onEdit(rowData)"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-copy"
        class="p-button-rounded p-button-text"
        [pTooltip]="'reports.tooltips.copy' | translate"
        tooltipPosition="top"
        (click)="onCopy(rowData)"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-file-edit"
        class="p-button-rounded p-button-text"
        [pTooltip]="'reports.tooltips.fill' | translate"
        tooltipPosition="top"
        (click)="onFill(rowData)"
      ></button>
      <button
        pButton
        type="button"
        icon="pi pi-trash"
        class="p-button-rounded p-button-text p-button-danger"
        [pTooltip]="'reports.tooltips.delete' | translate"
        tooltipPosition="top"
        (click)="onDelete(rowData)"
      ></button>
    </ng-template>
  </eko-generic-table>
</div>
